import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, ChevronRight } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";

interface WebWhoIsInTileProps {
    employees: any[];
    isLoading: boolean;
}

const WebWhoIsInTile: React.FC<WebWhoIsInTileProps> = ({ employees, isLoading }) => {
    const navigate = useNavigate();
    const { setSourcePath } = useNavigationHistory();

    const handleNavigate = () => {
        setSourcePath("/web-dashboard");
        navigate("/m-view-employees", { state: { from: "/web-dashboard" } });
    };

    const displayEmployees = employees?.slice(0, 6) || [];
    const remainingCount = (employees?.length || 0) - 6;

    return (
        <div className="p-6 h-full cursor-pointer" onClick={handleNavigate}>
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg text-blue-600 leading-tight hover:text-blue-600 transition-colors">
                    Who's Working Now
                </h2>
                <Users className="w-5 h-5 flex-shrink-0 text-gray-400" />
            </div>

            <div className="flex-1">
                {isLoading ? (
                    <div className="flex justify-center py-8">
                        <div className="w-6 h-6 border-2 border-t-transparent border-blue-600 rounded-full animate-spin"></div>
                    </div>
                ) : displayEmployees.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-full text-center">
                        <Users className="w-12 h-12 text-gray-300 mb-3" />
                        <p className="text-sm text-gray-500">No employees currently working</p>
                    </div>
                ) : (
                    <div className="space-y-3">
                        <div className="grid grid-cols-3 gap-3">
                            {displayEmployees.map((employee, index) => (
                                <div key={index} className="flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mb-2">
                                        <span className="text-sm font-medium text-blue-600">
                                            {employee.employee_name?.charAt(0) || 'U'}
                                        </span>
                                    </div>
                                    <div className="text-xs text-gray-600 truncate w-full">
                                        {employee.employee_name || 'Unknown'}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {remainingCount > 0 && (
                            <div className="text-center pt-2">
                                <span className="text-sm text-blue-600 font-medium">
                                    +{remainingCount} more
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WebWhoIsInTile; 